/*
 * assets/ce-mega-menu.js — <ce-mega-menu>
 *
 * Ergaenzt das Kategorie-Panel um zwei Dinge, die CSS nicht kann.
 *
 * Was OHNE dieses Skript schon funktioniert — und das ist der Punkt:
 * Das Panel oeffnet und schliesst ueber :hover und :focus-within des
 * Wrappers, mit der Maus wie mit der Tastatur. Alle Kategoriezeilen sind
 * Links, die Vorschau zeigt die erste Kategorie. Es gibt bewusst keinen
 * Umschaltknopf, den dieses Skript erst belegen muesste: ohne Skript waere
 * er tot, und ein toter Knopf ist schlimmer als keiner.
 *
 * Was dieses Skript hinzufuegt:
 *
 *   1. Vorschauwechsel. Faehrt der Zeiger ueber eine Kategorie oder wandert
 *      der Fokus dorthin, wechselt die Karte rechts. Reine Verstaerkung —
 *      die Karte traegt aria-hidden, weil jede Kategorie darin links bereits
 *      als Link steht.
 *   2. Escape schliesst. WCAG 1.4.13 verlangt, dass sich auf Hover
 *      eingeblendeter Inhalt schliessen laesst, OHNE den Zeiger oder den
 *      Fokus zu bewegen. Genau das leistet Escape hier.
 *
 * Der Escape-Zustand haelt nur bis zum naechsten Verlassen: sonst bliebe das
 * Panel fuer den Rest der Sitzung tot, obwohl der Nutzer es spaeter wieder
 * aufziehen will.
 */

class CEMegaMenu extends window.CE.Element {
  setup(signal) {
    this.panel = this.querySelector('.ce-mega__panel');
    if (!this.panel) return;

    this.cats = [...this.querySelectorAll('[data-mega-index]')];
    this.views = [...this.querySelectorAll('[data-mega-view]')];

    // Vorschauwechsel nur, wenn es ueberhaupt etwas zu wechseln gibt.
    if (this.views.length > 1) {
      this.cats.forEach((cat) => {
        const index = Number(cat.dataset.megaIndex);
        cat.addEventListener('pointerenter', () => this.show(index), { signal });
        // focus statt focusin: der Link selbst ist das Ziel, nicht seine Kinder.
        cat.addEventListener('focus', () => this.show(index), { signal });
      });
    }

    // Escape am Element, nicht am document: es greift nur, solange der Fokus
    // innerhalb liegt — sonst schluckte jedes Panel jede Escape-Taste.
    this.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      this.dismiss();
    }, { signal });

    // Der Riegel faellt, sobald Zeiger und Fokus draussen sind.
    this.addEventListener('pointerleave', () => this.restore(), { signal });
    this.addEventListener('focusout', (event) => {
      if (!this.contains(event.relatedTarget)) this.restore();
    }, { signal });
  }

  show(index) {
    this.cats.forEach((cat) => {
      cat.classList.toggle('is-current', Number(cat.dataset.megaIndex) === index);
    });
    this.views.forEach((view) => {
      view.classList.toggle('is-current', Number(view.dataset.megaView) === index);
    });
  }

  /**
   * Schliesst das Panel, obwohl Zeiger oder Fokus noch darauf liegen.
   * Der Fokus wandert auf den Ausloeser zurueck — bliebe er in einem
   * verborgenen Link stehen, waere er fuer den Nutzer verschwunden.
   */
  dismiss() {
    this.setAttribute('data-dismissed', '');
    const trigger = this.querySelector('.ce-mega__trigger');
    if (trigger && this.contains(document.activeElement)) trigger.focus();
  }

  restore() {
    this.removeAttribute('data-dismissed');
  }
}

customElements.define('ce-mega-menu', CEMegaMenu);
